export class Account{
    constructor(public cash: string, public cc: string, public loans: string, public investments: string, public property: string){};
}


// WEBPACK FOOTER //
// /Users/skye/Projects/Epicodus Projects/JavaScript/mock-mint/src/app/models/account-model.ts